import React from "react";

const InterestRate = () => (
  <div
    style={{ minHeight: "100vh", background: "#050A18", padding: "0 0 48px 0" }}
  >
    <div
      style={{
        background: "#111827",
        color: "#fff",
        padding: "56px 0 36px 0",
        textAlign: "center",
      }}
    >
      <div className="text-3xl font-bold tracking-wide text-center mb-2">
        <h2>
          <span className="text-[#4FA0FF]">Pricing</span>
          <span className="text-[white] ml-1">Policy</span>
        </h2>
        <p style={{ fontSize: "0.9rem", marginTop: 8, color: "#9ca3af" }}>
          (Interest & Charges)
        </p>
      </div>

      <p style={{ fontSize: "1.1rem", marginTop: 12, color: "#e0e0e0" }}>
        Brand Name: Kubermax | Approved by Board of Directors | Effective: 15 April 2025
      </p>
    </div>

    <div
      style={{
        maxWidth: 900,
        margin: "40px auto",
        background: "#111827",
        borderRadius: 16,
        boxShadow: "0 4px 24px 0 rgba(79, 160, 255, 0.1)",
        padding: "40px 28px",
        color: "#1D3557",
        fontSize: "1.08rem",
        lineHeight: 1.7,
        border: "1px solid gray",
      }}
    >
      <section style={{ marginBottom: 32 }}>
        <h2
          style={{
            fontSize: "1.3rem",
            fontWeight: 700,
            marginBottom: 12,
            color: "#4FA0FF",
          }}
        >
          Pricing Structure
        </h2>
        <p className="text-gray-300">
          Kubermax offers short-term financial assistance solutions designed for salaried individuals who require timely financial support. Our pricing structure is based on a transparent and structured model, which may include:
        </p>
        <ul style={{ paddingLeft: 20, listStyleType: "disc", marginTop: 12 }}>
          <li className="text-gray-300" style={{ marginBottom: "8px" }}>
            <strong>Processing Fees</strong>
          </li>
          <li className="text-gray-300" style={{ marginBottom: "8px" }}>
            <strong>Service Charges</strong>
          </li>
          <li className="text-gray-300" style={{ marginBottom: "8px" }}>
            <strong>Convenience Fees</strong>, depending on the nature of the service
          </li>
        </ul>
      </section>

      <section style={{ marginBottom: 32 }}>
        <h2
          style={{
            fontSize: "1.3rem",
            fontWeight: 700,
            marginBottom: 12,
            color: "#4FA0FF",
          }}
        >
          All Applicable Charges Are
        </h2>
        <ul style={{ paddingLeft: 20, listStyleType: "disc" }}>
          <li className="text-gray-300" style={{ marginBottom: "8px" }}>
            <strong>Clearly disclosed</strong> prior to disbursement
          </li>
          <li className="text-gray-300" style={{ marginBottom: "8px" }}>
            <strong>Determined based on factors</strong> such as tenure, risk profile, and operational costs
          </li>
          <li className="text-gray-300" style={{ marginBottom: "8px" }}>
            <strong>Designed to ensure sustainability</strong> of services while maintaining fairness
          </li>
        </ul>
      </section>

      <section>
        <p className="text-gray-300">
          Kubermax follows a responsible pricing approach inspired by microfinance best practices, where charges are structured to support operations without compromising transparency or customer understanding. <strong>There are no hidden charges</strong>, and customers are encouraged to review all details carefully before proceeding.
        </p>
        <div style={{ marginTop: "32px", paddingTop: "16px", borderTop: "1px solid rgba(75, 85, 99, 0.5)" }}>
          <p style={{ fontSize: "0.875rem", color: "#9ca3af", marginBottom: "4px" }}>
            <strong style={{ color: "#4FA0FF" }}>Approved By:</strong> Board of Directors
          </p>
          <p style={{ fontSize: "0.875rem", color: "#9ca3af" }}>
            <strong style={{ color: "#4FA0FF" }}>Effective From:</strong> 15 April 2025
          </p>
        </div>
      </section>
    </div>
  </div>
);

export default InterestRate;